export default __webpack_public_path__ + "static/media/writer.d12e48ea.png";